import { render, staticRenderFns } from "./dashboard_main.vue?vue&type=template&id=43555ff8&scoped=true&"
import script from "./dashboard_main.vue?vue&type=script&lang=js&"
export * from "./dashboard_main.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_main.vue?vue&type=style&index=0&id=43555ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43555ff8",
  null
  
)

export default component.exports